import React, { useState } from 'react';
import {
    Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import League from '../pages/League';
import { FaFlagUsa, FaFlag } from 'react-icons/fa';
import { useAuth } from './AuthContext';

export function NavMenu() {
    const { t, i18n } = useTranslation();
    const [collapsed, setCollapsed] = useState(true);
    const [feedbackDropdownOpen, setFeedbackDropdownOpen] = useState(false);
    const [trainingDropdownOpen, setTrainingDropdownOpen] = useState(false);
    const [eventDropdownOpen, setEventDropdownOpen] = useState(false);
    const auth = useAuth();

    const toggleFeedbackDropdown = () => {
        setFeedbackDropdownOpen(!feedbackDropdownOpen);
    }
    const toggleTrainingDropdown = () => {
        setTrainingDropdownOpen(!trainingDropdownOpen);
    }

    const toggleEventDropdown = () => {
        setEventDropdownOpen(!eventDropdownOpen);
    }

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const handleLogout = async () => {
        try {
            const response = await fetch('/auth/session/signout', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.ok) {
                window.location.href = '/login';
                console.log("Logout Success");
            }
            console.error("Logout failed. Status:", response.status);
        } catch (error) {
            console.error('Failed to check login status', error);
        }
    };

    const location = useLocation();
    const hideNavbarPaths = ['/league', '/peraduan-ramadan', '/submission-log', '/tnc-improvement'];
    const shouldHideNavbar = hideNavbarPaths.includes(location.pathname);
    const pathnames = location.pathname.split("/").filter(x => x);

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3 navbar-color" container light>
                <NavbarBrand tag={Link} className="nav-text" to="/">
                    <img src={'https://assets.grab.com/wp-content/uploads/media/grab_logo.png'} width="80px" alt="Odin" />
                </NavbarBrand>

                <div className="div-language">
                    <button className="btn-language" onClick={() => changeLanguage('en')} disabled={i18n.language === 'en'}>
                        <img src="globe.png" alt="Globe" style={{ width: '20px', marginTop: '1px' }} />
                        {t('nav.english')}
                    </button>
                    <button className="btn-language" onClick={() => changeLanguage('ms')} disabled={i18n.language === 'ms'}>
                        <img src="my_flag.png" alt="Malay Flag" style={{ width: '20px', marginTop: '1px' }} />
                        {t('nav.malay')}
                    </button>
                </div>
                {auth.isLoggedIn && (
                    <div>
                        <NavbarToggler onClick={toggleNavbar} className="mr-2 nav-toggler">
                            <i className="fa fa-bars bars" aria-hidden="true"></i>
                        </NavbarToggler>
                    </div>
                )}
                {auth.isLoggedIn && (
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={Link} className="nav-main-text" to="/">
                                    <i className="fa fa-user" aria-hidden="true"></i> {t('nav.profile')}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <Dropdown isOpen={trainingDropdownOpen} toggle={toggleTrainingDropdown}>
                                    <DropdownToggle nav caret className='dropdown-toggle'>
                                        <i className="fa fa-book"></i>  {'Training'}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem className='center-dropdown'>
                                            <NavLink tag={Link} className="navbar-text" to="/premium-hvr-training">
                                                {'Premium Training' }
                                            </NavLink>
                                        </DropdownItem>
                                        <DropdownItem className='center-dropdown'>
                                            <NavLink tag={Link} className="navbar-text" to="/hvr-training">
                                                {'Executive Training'}
                                            </NavLink>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </NavItem>
                            <NavItem>
                                <Dropdown isOpen={feedbackDropdownOpen} toggle={toggleFeedbackDropdown}>
                                    <DropdownToggle nav caret className='dropdown-toggle'>
                                        <i className="fa fa-comments"></i>  {t('nav.menuFeedback')}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem className='center-dropdown'>
                                            <NavLink tag={Link} className="navbar-text" to="/improved-feedback">
                                                {t('nav.eagle')}
                                            </NavLink>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </NavItem>
                            <NavItem>
                                <Dropdown isOpen={eventDropdownOpen} toggle={toggleEventDropdown}>
                                    <DropdownToggle nav caret className='dropdown-toggle'>
                                        <i className="fa fa-calendar"></i>  {t('nav.menuEvent')}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem className='center-dropdown'>
                                            <NavLink tag={Link} className="navbar-text" to="/submission-log">
                                                {t('nav.eagle')}
                                            </NavLink>
                                        </DropdownItem>
                                        <DropdownItem className='center-dropdown'>
                                            <NavLink tag={Link} className="navbar-text" to="/league">
                                                {t('nav.liga')}
                                            </NavLink>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </NavItem>
                            <NavItem>
                                <div className='nav-main-text nav-pointer' onClick={handleLogout}>
                                    <i className="fa fa-sign-out"></i> {t('nav.logout')}
                                </div>
                            </NavItem>
                        </ul>
                    </Collapse>
                )}
            </Navbar>
            <div className="container">
                {auth.isLoggedIn && (
                    <nav className="breadcrumb-container" aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <NavLink tag={Link} to="/">
                                    <i className="fa fa-home"></i> Home
                                </NavLink>
                            </li>
                            {pathnames.map((value, index) => {
                                const link = `/${pathnames.slice(0, index + 1).join("/")}`;
                                const displayValue =
                                    value === 'submission-log' ? 'Improved Earnings' :
                                        value === 'league' ? 'Liga Juara Rakan Grab' :
                                            value;
                                return (
                                    <li key={index} className="breadcrumb-item">
                                        <NavLink tag={Link} to={link}>
                                            <i className="fa fa-angle-right"></i>{displayValue}
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ol>
                    </nav>
                )}
            </div>
        </header>
    );
}